/**
 * Forbrukerrett Module Description
 * Master Grade modul for forbrukerrettslige prosesser
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const FORBRUKERRETT_CONFIG = {
  id: 'forbrukerrett',
  title: 'Forbrukerrett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen rettsområdet med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte dokumentutkast. Modulen er utviklet for å gi et helhetlig arbeidsverktøy for håndtering av forbrukerkjøp og reklamasjonssaker.",
  
  aboutModule: "Forbrukerrett-modulen hjelper deg med å strukturere og håndtere reklamasjoner, mangelsvurderinger og angrerettsspørsmål – fra dokumentasjon og kvitteringer til ferdig klageutkast.",
  
  features: [
    "OCR-skanning av kvitteringer og dokumenter med norsk tekstgjenkjenning",
    "AI-drevet argumentgenerator basert på forbrukerkjøpsloven og angrerettloven",
    "Automatisk beregning av angrerett, reklamasjonsfrister og øvrige relevante tidsfrister",
    "Analyse av selgers svar med forslag til motargumenter",
    "Komplett eksportpakke til bruk for Forbrukerklageutvalget (FKU)"
  ],
  
  privacyText: "All behandling og lagring skjer lokalt på din enhet. Dokumenter og metadata krypteres med AES-256. Ingenting lastes opp eller deles med RettVerk."
};

export function ForbrukerrettDescription() {
  const config = FORBRUKERRETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default ForbrukerrettDescription;
